import { dispatchEventToNative } from "@src/utils/dispatchEventToNative";
import { destroyCache } from "@src/utils/serviceWorker/destroyCache";
import { setQueryString } from "@src/utils/setQueryString";

export function updateVersion(idRadio: string) {
  destroyCache(idRadio, "DESTROY_PRECACHE").then(() => {
    dispatchEventToNative("destroy_cache");

    window.location.href = setQueryString(
      window.location.href,
      "autoplay",
      "1",
    );
  });
}
